// Gallery Configuration Constants
export const GALLERY_CONFIG = {
  // 3D Gallery Settings
  ARTWORK_RADIUS: 5,
  ARTWORK_SIZE: 1.2,
  ARTWORK_SEGMENTS: 64,
  CAMERA_POSITION: [0, 0, 8],
  CAMERA_FOV: 75,
  
  // Proximity Scaling
  PROXIMITY_SCALING: {
    BASE_SCALE: 1.0,
    MAX_SCALE: 1.4,
    MIN_DISTANCE: 3,
    MAX_DISTANCE: 15,
    SELECTED_BOOST: 1.1,
    LERP_SPEED: 0.05
  },
  
  // Animation Settings
  FLOATING_AMPLITUDE: 0.08,
  ROTATION_SPEED: 2,
  ROTATION_AMPLITUDE: 0.02,
  
  // Blur Effect
  BLUR_AMOUNT: 0.8,
  BLUR_LERP_SPEED: 0.1,
  
  // Lighting
  TONE_MAPPING_EXPOSURE: 1.2,
  CONTACT_SHADOWS: {
    POSITION: [0, -2, 0],
    OPACITY: 0.4,
    SCALE: 20,
    BLUR: 2,
    FAR: 4
  },
  
  // Orbit Controls
  ORBIT_CONTROLS: {
    MIN_DISTANCE: 3,
    MAX_DISTANCE: 15,
    AUTO_ROTATE_SPEED: 0.5
  },
  
  // Orbital Rings System
  ORBITAL_RINGS: {
    COUNT: 3,
    BASE_RADIUS: 3,
    RADIUS_INCREMENT: 1.5,
    HEIGHT_VARIATION: 1,
    ROTATION_SPEEDS: [0.002, -0.003, 0.001], // Different speeds for each ring
    GLOW_COLOR: '#4a90e2',
    OPACITY: 0.3,
    LINE_WIDTH: 0.02
  }
};

// Color Palette for Adaptive Lighting
export const ADAPTIVE_COLORS = [
  '#ff6b6b', '#4ecdc4', '#45b7d1', 
  '#f9ca24', '#6c5ce7', '#a55eea'
];

// Animation Types for 2D Gallery
export const ANIMATION_TYPES = [
  'shake', 'tilt', 'pulse', 'bounce'
];

// Particle Colors
export const PARTICLE_COLORS = {
  shake: '#ff4757',
  tilt: '#2ed573', 
  pulse: '#a55eea',
  bounce: '#ffa502'
};
